  import React, { useEffect, useState } from 'react';

  function IdentificationTab({ form, handleChange }) {
    const [age, setAge] = useState('');

    useEffect(() => {
      if (form.birthDate) {
        const ageText = calculateAge(form.birthDate);
        setAge(ageText);
      } else {
        setAge('');
      }
    }, [form.birthDate]);

    const calculateAge = (birthDateString) => {
      const birthDate = new Date(birthDateString);
      const today = new Date();

      let years = today.getFullYear() - birthDate.getFullYear();
      let months = today.getMonth() - birthDate.getMonth();
      let days = today.getDate() - birthDate.getDate();

      if (days < 0) {
        months--;
        days += new Date(today.getFullYear(), today.getMonth(), 0).getDate(); // days in prev month
      }

      if (months < 0) {
        years--;
        months += 12;
      }

      return `${years} years, ${months} months, ${days} days`;
    };

    return (
      <div className="row">
        
        <div className="col-md-4 mb-3">
          <label className="form-label">Document Type</label>
          <select
            className="form-select"
            name="idDocument"
            value={form.idDocument}
            onChange={handleChange}
          >
            <option value="">Select</option>
          
            <option>Aadhaar Card</option>
            <option>Driving License</option>
              <option>PAN Card</option>
              <option>Passport</option>
            <option>Other</option>
          </select>
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Document Number</label>
          <input
            className="form-control"
            name="idNumber"
            value={form.idNumber}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4 mb-3">
          <label className="form-label">Birth Date</label>
          <input
            type="date"
            className="form-control"
            name="birthDate"
            value={form.birthDate}
            onChange={handleChange}
          />
          {age && (
            <div className="form-text text-success mt-1">
              🧓 Age: {age}
            </div>
          )}
        </div>
      </div>
    );
  }

  export default IdentificationTab;
